import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TemplatesService } from '../../../services/templates.service';
import { CompaniesService } from '../../../services/companies.service';
import { AccountsService } from '../../../services/accounts.service';
import { AlertService } from '../../../services/alert.service';
import { useForm, Controller } from 'react-hook-form';
import Icon from '../../../components/forms/icon.component';
import Header from '../../../components/layout/header.component';
import Asaid from '../../../components/layout/asaid.component';
import Footer from '../../../components/layout/footer.component';
import useBgPages from '../../../hooks/use-bg-pages.hook';
import Select from 'react-select';
import Datatable from '../../../components/datatable/datatable.component';
import TypeRCS from '../rcs/modal/type-rcs.modal';
import ActionsDropdown from '../../../components/datatable/actions-dropdown.component';
import LogData from '../../../components/logs/log-data.component';
import useRequest from '../../../hooks/use-request.hook';
import AndroidMockup from '../../../components/mockups/android.component';
import Tooltip from '../../../components/forms/tooltip.component';
import PrincipalCard from '../../../components/cards/principal-card.component';
import { useSession } from '../../../hooks/use-session.hook';
import { PROFILES } from '../../../constants';
import SendMessageRCS from './modal/send-message.modal';

interface Data {
  type: string;
  _id: string;
  name: string;
  status: boolean;
  created_at: string;
  updated_at: string;
}

export const extractPreviewFromTemplate = (template: any) => {
  if (!template) return [];

  if (template.type === 'BASIC' && template.basic) {
    return [
      {
        type: 'basic',
        message: template.basic.text || '',
        suggestions: []
      }
    ];
  }

  if (template.type === 'SINGLE' && template.single && Array.isArray(template.single)) {
    return template.single
      .map((item: any, index: number) => {
        if (item.richCard?.standaloneCard) {
          const card = item.richCard.standaloneCard;
          const content = card.cardContent;

          return {
            type: 'richCard',
            URLImage: content.media?.contentInfo?.fileUrl || '',
            URLImagePoster: content.media?.contentInfo?.thumbnailUrl || '',
            URLVideo: '',
            title: content.title || '',
            description: content.description || '',
            gnlLabel: '',
            linkURL: '',
            phoneNumber: '',
            label: '',
            latitude: 0,
            longitude: 0,
            startTime: '',
            endTime: '',
            titleC: '',
            descriptionC: '',
            typeAction: '',
            imageCheck: !!content.media?.contentInfo?.fileUrl,
            videoCheck: false,
            suggestedReply: false,
            suggestedAction: false,
            actions:
              content.suggestions?.map((suggestion: any) => ({
                type: suggestion.reply ? 'answer' : 'redirect',
                gnlLabel: suggestion.reply?.text || suggestion.action?.text || '',
                linkURL: suggestion.action?.openUrlAction?.url || '',
                phoneNumber: suggestion.action?.dialAction?.phoneNumber || '',
                label: '',
                latitude: suggestion.action?.createCalendarEventAction?.startTime
                  ? suggestion.action.viewLocationAction?.latLong?.latitude || 0
                  : 0,
                longitude: suggestion.action?.createCalendarEventAction?.startTime
                  ? suggestion.action.viewLocationAction?.latLong?.longitude || 0
                  : 0,
                startTime: suggestion.action?.createCalendarEventAction?.startTime || '',
                endTime: suggestion.action?.createCalendarEventAction?.endTime || '',
                titleC: suggestion.action?.createCalendarEventAction?.title || '',
                descriptionC: suggestion.action?.createCalendarEventAction?.description || ''
              })) || [],
            suggestions:
              item.suggestions?.map((suggestion: any) => ({
                type: 'answer',
                gnlLabel: suggestion.reply?.text || '',
                linkURL: '',
                phoneNumber: '',
                label: '',
                latitude: 0,
                longitude: 0,
                startTime: '',
                endTime: '',
                titleC: '',
                descriptionC: ''
              })) || []
          };
        }

        if (item.richCard?.carouselCard) {
          const carousel = item.richCard.carouselCard;

          return {
            type: 'richCard_Carrosuel',
            cards:
              carousel.cardContents?.map((cardContent: any) => ({
                type: 'richCard',
                URLImage: cardContent.media?.contentInfo?.fileUrl || '',
                URLImagePoster: cardContent.media?.contentInfo?.thumbnailUrl || '',
                URLVideo: '',
                title: cardContent.title || '',
                description: cardContent.description || '',
                gnlLabel: '',
                linkURL: '',
                phoneNumber: '',
                imageCheck: !!cardContent.media?.contentInfo?.fileUrl,
                videoCheck: false,
                suggestedReply: false,
                suggestedAction: false,
                actions:
                  cardContent.suggestions?.map((suggestion: any) => ({
                    type: suggestion.reply
                      ? 'answer'
                      : suggestion.action?.dialAction
                        ? 'call'
                        : suggestion.action?.openUrlAction
                          ? 'redirect'
                          : suggestion.action?.viewLocationAction
                            ? 'location'
                            : suggestion.action?.createCalendarEventAction
                              ? 'calendar'
                              : 'redirect',
                    gnlLabel: suggestion.reply?.text || suggestion.action?.text || '',
                    linkURL: suggestion.action?.openUrlAction?.url || '',
                    phoneNumber: suggestion.action?.dialAction?.phoneNumber || '',
                    label: '',
                    latitude: suggestion.action?.viewLocationAction?.latLong?.latitude || 0,
                    longitude: suggestion.action?.viewLocationAction?.latLong?.longitude || 0,
                    startTime: suggestion.action?.createCalendarEventAction?.startTime || '',
                    endTime: suggestion.action?.createCalendarEventAction?.endTime || '',
                    titleC: suggestion.action?.createCalendarEventAction?.title || '',
                    descriptionC: suggestion.action?.createCalendarEventAction?.description || ''
                  })) || []
              })) || [],
            suggestions:
              item.suggestions?.map((suggestion: any) => ({
                type: 'answer',
                gnlLabel: suggestion.reply?.text || '',
                linkURL: '',
                phoneNumber: '',
                label: '',
                latitude: 0,
                longitude: 0,
                startTime: '',
                endTime: '',
                titleC: '',
                descriptionC: ''
              })) || []
          };
        }

        if (item.contentInfo) {
          const contentInfo = item.contentInfo;

          return {
            type: 'contenInfo',
            URLImage: contentInfo.fileUrl || '',
            URLImagePoster: contentInfo.thumbnailUrl || '',
            URLVideo: '',
            URLFile: '',
            imageCheck: !!contentInfo.fileUrl,
            videoCheck: false,
            fileCheck: false,
            forceRefresh: contentInfo.forceRefresh || false,
            suggestions:
              item.suggestions?.map((suggestion: any) => ({
                type: 'answer',
                gnlLabel: suggestion.reply?.text || '',
                linkURL: '',
                phoneNumber: '',
                label: '',
                latitude: 0,
                longitude: 0,
                startTime: '',
                endTime: '',
                titleC: '',
                descriptionC: ''
              })) || []
          };
        }

        console.log(`❌ Item ${index} no reconocido en SINGLE:`, item);
        return null;
      })
      .filter(Boolean);
  }

  if (
    template.type === 'CONVERSATIONAL' &&
    template.conversational &&
    Array.isArray(template.conversational)
  ) {
    return template.conversational
      .map((item: any, index: number) => {
        if (item.richCard?.standaloneCard) {
          const card = item.richCard.standaloneCard;
          const content = card.cardContent;

          return {
            type: 'richCard',
            URLImage: content.media?.contentInfo?.fileUrl || '',
            URLImagePoster: content.media?.contentInfo?.thumbnailUrl || '',
            URLVideo: '',
            title: content.title || '',
            description: content.description || '',
            gnlLabel: '',
            linkURL: '',
            phoneNumber: '',
            label: '',
            latitude: 0,
            longitude: 0,
            startTime: '',
            endTime: '',
            titleC: '',
            descriptionC: '',
            typeAction: '',
            imageCheck: !!content.media?.contentInfo?.fileUrl,
            videoCheck: false,
            suggestedReply: false,
            suggestedAction: false,
            actions:
              content.suggestions?.map((suggestion: any) => ({
                type: suggestion.reply
                  ? 'answer'
                  : suggestion.action?.dialAction
                    ? 'call'
                    : suggestion.action?.openUrlAction
                      ? 'redirect'
                      : suggestion.action?.viewLocationAction
                        ? 'location'
                        : suggestion.action?.createCalendarEventAction
                          ? 'calendar'
                          : 'redirect',
                gnlLabel: suggestion.reply?.text || suggestion.action?.text || '',
                linkURL: suggestion.action?.openUrlAction?.url || '',
                phoneNumber: suggestion.action?.dialAction?.phoneNumber || '',
                label: '',
                latitude: suggestion.action?.viewLocationAction?.latLong?.latitude || 0,
                longitude: suggestion.action?.viewLocationAction?.latLong?.longitude || 0,
                startTime: suggestion.action?.createCalendarEventAction?.startTime || '',
                endTime: suggestion.action?.createCalendarEventAction?.endTime || '',
                titleC: suggestion.action?.createCalendarEventAction?.title || '',
                descriptionC: suggestion.action?.createCalendarEventAction?.description || ''
              })) || [],
            suggestions:
              item.suggestions?.map((suggestion: any) => ({
                type: 'answer',
                gnlLabel: suggestion.reply?.text || '',
                linkURL: '',
                phoneNumber: '',
                label: '',
                latitude: 0,
                longitude: 0,
                startTime: '',
                endTime: '',
                titleC: '',
                descriptionC: ''
              })) || []
          };
        }

        if (item.richCard?.carouselCard) {
          const carousel = item.richCard.carouselCard;

          return {
            type: 'richCard_Carrosuel',
            cards:
              carousel.cardContents?.map((cardContent: any) => ({
                type: 'richCard',
                URLImage: cardContent.media?.contentInfo?.fileUrl || '',
                URLImagePoster: cardContent.media?.contentInfo?.thumbnailUrl || '',
                URLVideo: '',
                title: cardContent.title || '',
                description: cardContent.description || '',
                gnlLabel: '',
                linkURL: '',
                phoneNumber: '',
                imageCheck: !!cardContent.media?.contentInfo?.fileUrl,
                videoCheck: false,
                suggestedReply: false,
                suggestedAction: false,
                actions:
                  cardContent.suggestions?.map((suggestion: any) => ({
                    type: suggestion.reply
                      ? 'answer'
                      : suggestion.action?.dialAction
                        ? 'call'
                        : suggestion.action?.openUrlAction
                          ? 'redirect'
                          : suggestion.action?.viewLocationAction
                            ? 'location'
                            : suggestion.action?.createCalendarEventAction
                              ? 'calendar'
                              : 'redirect',
                    gnlLabel: suggestion.reply?.text || suggestion.action?.text || '',
                    linkURL: suggestion.action?.openUrlAction?.url || '',
                    phoneNumber: suggestion.action?.dialAction?.phoneNumber || '',
                    label: '',
                    latitude: suggestion.action?.viewLocationAction?.latLong?.latitude || 0,
                    longitude: suggestion.action?.viewLocationAction?.latLong?.longitude || 0,
                    startTime: suggestion.action?.createCalendarEventAction?.startTime || '',
                    endTime: suggestion.action?.createCalendarEventAction?.endTime || '',
                    titleC: suggestion.action?.createCalendarEventAction?.title || '',
                    descriptionC: suggestion.action?.createCalendarEventAction?.description || ''
                  })) || []
              })) || [],
            suggestions:
              item.suggestions?.map((suggestion: any) => ({
                type: 'answer',
                gnlLabel: suggestion.reply?.text || '',
                linkURL: '',
                phoneNumber: '',
                label: '',
                latitude: 0,
                longitude: 0,
                startTime: '',
                endTime: '',
                titleC: '',
                descriptionC: ''
              })) || []
          };
        }

        if (item.contentInfo) {
          const contentInfo = item.contentInfo;

          return {
            type: 'contenInfo',
            URLImage: contentInfo.fileUrl || '',
            URLImagePoster: contentInfo.thumbnailUrl || '',
            URLVideo: '',
            URLFile: '',
            imageCheck: !!contentInfo.fileUrl,
            videoCheck: false,
            fileCheck: false,
            forceRefresh: contentInfo.forceRefresh || false,
            suggestions:
              item.suggestions?.map((suggestion: any) => ({
                type: 'answer',
                gnlLabel: suggestion.reply?.text || '',
                linkURL: '',
                phoneNumber: '',
                label: '',
                latitude: 0,
                longitude: 0,
                startTime: '',
                endTime: '',
                titleC: '',
                descriptionC: ''
              })) || []
          };
        }

        console.log(`❌ Item ${index} no reconocido en CONVERSATIONAL:`, item);
        return null;
      })
      .filter(Boolean);
  }

  return [];
};
function TemplatesRcsPage() {
  useBgPages();
  const { t } = useTranslation();
  const { session, selectedAccount } = useSession();
  const navigate = useNavigate();
  const { call, isRequesting } = useRequest();
  const [rows, setRows] = useState<Data[]>([]);
  const [dataPreview, setDataPreview] = useState('');
  const [typePreview, setTypePreview] = useState('');
  const [companies, setCompanies] = useState<any[]>([]);
  const [selectedCompany, setSelectedCompany] = useState('');
  const [account, setAccount] = useState<any[]>([]);
  const [totalBasic, setTotalBasic] = useState(0);
  const [totalSingle, setTotalSingle] = useState(0);
  const [totalConversational, setTotalConversational] = useState(0);
  const [filtersActive, setFiltersActive] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState<any>(null);
  const [showModalTypeRCS, setShowModalTypeRCS] = useState({
    show: false,
    data: null
  });

  const [showModalMessageRCS, setShowModalMessageRCS] = useState({
    show: false,
    data: null
  });

  const handleSendMessage = (row: any) => {
    setSelectedTemplate(row);
    setShowModalMessageRCS({
      show: true,
      data: row
    });
  };

  const dataStatistics = [
    { label: 'Básico', total: totalBasic, type: '', icon: 'ki-messages' },
    { label: 'Simple', total: totalSingle, type: 'info', icon: 'ki-messages' },
    { label: 'Conversacional', total: totalConversational, type: 'primary', icon: 'ki-messages' }
  ];

  const { control, watch, setValue } = useForm({
    mode: 'onChange'
  });

  const accountFilter = watch('account');
  const companiesFilter = watch('companies');

  const columns = [
    {
      name: t('templates.rcs.name'),
      sortable: true,
      selector: (r: any) => `${r.name} ${r.account?.company?.name} ${r.account?.name}`,
      width: 25,
      cell: (row: any) => {
        return (
          <ul className="list-group-item text-nowrap">
            <li className="list-group-item">
              <div className="d-flex flex-column">
                <div className="w-100 mb-1">
                  <strong className="fs-6">Nombre:</strong>
                  <span className="ms-1">{row?.name || t('general.no-info')}</span>
                </div>
                {session.profile === PROFILES.ROOT && (
                  <>
                    <div className="w-100 mb-1">
                      <strong className="fs-6">Empresa:</strong>
                      <span className="ms-1">
                        {row.account?.company?.name || t('general.no-info')}
                      </span>
                    </div>
                    <div className="w-100 mb-1">
                      <strong className="fs-6">Cuenta:</strong>
                      <span className="ms-1">{row?.account?.name || t('general.no-info')}</span>
                    </div>
                  </>
                )}
              </div>
            </li>
          </ul>
        );
      }
    },
    {
      name: t('templates.rcs.rcs-type'),
      sortable: true,
      center: false,
      selector: (r: any) => `${r.type}`,
      width: 25,
      cell: (row: any) => {
        const typeMapping: Record<string, string> = {
          basic: t('templates.rcs.basic'),
          single: t('templates.rcs.single'),
          conversational: t('templates.rcs.conversational')
        };
        const translatedType = typeMapping[row.type.toLowerCase()] || row.type;
        const className =
          row.type.toLowerCase() === 'single'
            ? 'text-info fw-bolder'
            : row.type.toLowerCase() === 'conversational'
              ? 'text-primary fw-bolder'
              : 'fw-bolder';

        return (
          <div className="d-flex align-items-center justify-content-start gap-2">
            <Icon
              icon="ki-messages"
              size="fs-2x"
              type={className}
              className={`hover-scale ${className}`}
            />
            <span className={`fw-semibold`}>{translatedType}</span>
          </div>
        );
      }
    },
    {
      name: t('templates.rcs.preview'),
      sortable: true,
      center: true,
      selector: (r: any) => `${r._id}`,
      width: 30,
      cell: (row: any) => (
        <button
          className="btn btn-light btn-sm hover-scale fw-bolder text-nowrap"
          type="button"
          onClick={() => handlePreview(row)}
        >
          <Icon icon="ki-eye" size="fs-2" />
          Vista previa
        </button>
      )
    },
    {
      name: 'Status',
      sortable: true,
      center: true,
      selector: (r: any) => `${r.status}`,
      width: 25,
      cell: (row: any) =>
        row.status ? (
          <span className="badge text-dark fs-6">
            <Icon icon="ki-check-circle" size="fs-3" type="primary" />
            {t('general.active')}
          </span>
        ) : (
          <span className="badge text-danger fs-6">
            <Icon icon="ki-minus-circle" size="fs-3" type="danger" />
            {t('general.inactive')}
          </span>
        )
    },
    {
      name: t('general.acctions'),
      sortable: true,
      selector: (r: any) => `${r._id}`,
      center: true,
      exportable: false,
      cell: (rows: any) => {
        const options = [
          {
            label: 'Enviar mensaje Prueba',
            icon: 'ki-send',
            color: 'info',
            onClick: () => {
              handleSendMessage(rows);
            }
          }
        ];
        return (
          <ActionsDropdown
            options={options}
            edit={rows.status ? () => handleEditRCS({ rows }) : undefined}
            changeStatus={() =>
              handleChangeStatus(rows._id, 'changeStatusTemplatesRCS-4528604568', rows.status)
            }
            rowStatus={rows.status}
            delete={() => handleDeleteTemplate(rows._id, rows.name, 'deleteTemplateRCS-9174562789')}
          />
        );
      }
    }
  ];

  const handleEditRCS = async (payload: any) => {
    const routes: Record<string, string> = {
      basic: '/templates-panel/templates-rcs-builder-basic',
      single: '/templates-panel/templates-rcs-builder-single',
      conversational: '/templates-panel/templates-rcs-builder-conversational'
    };
    const route = routes[payload.rows.type.toLowerCase()];
    if (route) {
      navigate(route, { state: { payload } });
    }
  };

  const handleChangeStatus = async (id: string, buttonId: string, status: boolean) => {
    const isConfirmed = await AlertService.warning(
      t('general.atention'),
      '¿Quieres cambiar el status de tu plantilla?',
      () => Promise.resolve(true)
    );
    if (!isConfirmed) return;
    try {
      await TemplatesService.changeStatusTemplatesRCS(id, { status: status ? false : true });
      AlertService.toastSuccess(t('roles.change-status-success'));
      await getTemplates();
      LogData({ id: id, status: status ? 'disable' : 'enable' }, buttonId, window.location.href);
      resetPreview();
    } catch (errorCode: any) {
      console.log('Error:', errorCode);
      AlertService.toastError(errorCode.error || errorCode);
      resetPreview();
    }
  };

  const handleDeleteTemplate = async (id: string, name: string, buttonId: string) => {
    try {
      const confirmed = await AlertService.question(
        t('general.atention'),
        `¿Quiere eliminar tu plantilla?, ${name}`,
        null as any,
        'Eliminar'
      );
      if (!confirmed) {
        return;
      }
      await TemplatesService.deleteTemplateRCS(id);
      resetPreview();
      AlertService.toastSuccess(t('channels.wa.success1'));
      await getTemplates();
      LogData(id, buttonId, window.location.href);
    } catch (errorCode: any) {
      console.log('Error:', errorCode);
      AlertService.toastError(errorCode.error || errorCode);
      resetPreview();
    }
  };
  const handlePreview = (row: any) => {
    const getPreviewData = (template: any) => {
      if (template.preview && Array.isArray(template.preview) && template.preview.length > 0) {
        return template.preview;
      }
      return extractPreviewFromTemplate(template);
    };

    const previewData = getPreviewData(row);

    setDataPreview({ ...row, preview: previewData });
    setTypePreview(row.type.toLowerCase());
    setSelectedTemplate(row);
  };

  const getTemplates = async () => {
    try {
      let data = [];
      if (session.profile === PROFILES.ROOT) {
        data = !filtersActive
          ? await call(() => TemplatesService.getAllTemplatesRCS())
          : await call(() => TemplatesService.getTemplatesAccountRCS(watch('account')));
      } else if (session.profile === PROFILES.ADMIN) {
        data = await call(() =>
          TemplatesService.getTemplatesAccountRCS(selectedAccount.account_id)
        );
      }
      setRows(data);
      const totals = data?.reduce(
        (acc: any, item: any) => {
          if (item.type.toLowerCase() === 'basic') acc.totalBasic += 1;
          if (item.type.toLowerCase() === 'single') acc.totalSingle += 1;
          if (item.type.toLowerCase() === 'conversational') acc.totalConversational += 1;
          return acc;
        },
        { totalBasic: 0, totalSingle: 0, totalConversational: 0 }
      );

      if (totals) {
        setTotalBasic(totals.totalBasic);
        setTotalSingle(totals.totalSingle);
        setTotalConversational(totals.totalConversational);
      }
      resetPreview();
    } catch (errorCode: any) {
      console.log('Error:', errorCode);
      AlertService.toastError(errorCode.error || errorCode);
      resetPreview();
    }
  };

  const getCompanies = async () => {
    try {
      const data = await CompaniesService.getCompanies();
      setCompanies(
        data.map((item: any) => ({
          value: item._id,
          label: item.name
        }))
      );
    } catch (errorCode: any) {
      console.log('Error:', errorCode);
      AlertService.toastError(errorCode.error || errorCode);
      setCompanies([]);
    }
  };

  const getAccount = async () => {
    if (selectedCompany)
      try {
        const data = await AccountsService.getAccountsForCompany(selectedCompany);
        setAccount(
          data.map((item: any) => ({
            value: item._id,
            label: item.name
          }))
        );
      } catch (errorCode: any) {
        console.log('Error:', errorCode);
        AlertService.toastError(errorCode.error || errorCode);
        setAccount([]);
      }
  };

  const resetPreview = async () => {
    setDataPreview('');
    setTypePreview('');
  };

  useEffect(() => {
    const fetchData = async () => {
      await getTemplates();
    };

    fetchData();
  }, [filtersActive, watch('account')]);

  useEffect(() => {
    getCompanies();
  }, []);

  useEffect(() => {
    setAccount([]);
    if (selectedCompany) {
      getAccount();
    }
  }, [selectedCompany]);

  useEffect(() => {
    if (accountFilter && companiesFilter) {
      setFiltersActive(true);
    } else {
      setFiltersActive(false);
    }
  }, [accountFilter, companiesFilter]);

  useEffect(() => {
    const initAdminData = async () => {
      if (session.profile === PROFILES.ADMIN && selectedAccount?.account_id) {
        setValue('account', selectedAccount.account_id);
        setFiltersActive(true);
        await getTemplates();
      }
    };

    initAdminData();
  }, [session.profile, selectedAccount]);

  return (
    <>
      <div className="page d-flex flex-row flex-column-fluid">
        <Asaid />
        <div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
          <Header />
          <div className="content fs-6 d-flex flex-column flex-column-fluid" id="kt_content">
            <div className="post fs-6 d-flex flex-column-fluid" id="kt_post">
              <div className="container-xxl">
                <PrincipalCard
                  returnExtrict="/templates-panel"
                  dataStatistics={dataStatistics}
                  btnCreate
                  onClick={() => setShowModalTypeRCS({ show: true, data: null })}
                  btnRefresh
                  onRefresh={async () => {
                    await getTemplates();
                    AlertService.toastSuccess('¡ Éxito !, información actualizada.');
                  }}
                  btnBack
                  title="Plantillas"
                  titleBolder="RCS"
                  subtitle="Perzonaliza y gestiona tus plantillas."
                  breadcrumbItems={['tools.tools-title', 'asaid.link-templates']}
                  textButton="Agregar plantilla"
                  iconButton="ki-soft-2"
                />
                <div className="row g-xl-10">
                  <div className="col-xl-8 mb-5">
                    <div className="card">
                      <div className="card-header align-items-center border-0 mt-5">
                        <div className="card-title align-items-start flex-column animate-fadeInUp animate-delay-1 h3">
                          <span className="fw-bolder fw-bold fs-2">
                            {t('templates.rcs.templates-title')}
                            <Tooltip
                              title={
                                'No es necesario configurar previamente los agentes de RCS; las plantillas solo se vinculan a las cuentas de una empresa.'
                              }
                              className="d-inline-block cursor-pointer"
                            >
                              <Icon
                                icon="ki-information-3"
                                size="fs-1"
                                className="ms-2"
                                type="info"
                              />
                            </Tooltip>
                          </span>
                          <span className="text-gray-700 mt-2 fw-semibold fs-6">
                            {t('templates.rcs.registered')}
                          </span>
                        </div>
                        {session.profile === PROFILES.ROOT && (
                          <div className="card-toolbar">
                            <button
                              type="button"
                              className={`btn ${filtersActive ? 'btn-light-primary' : 'btn-dark'} btn-center`}
                              data-kt-menu-trigger="{default: 'hover', lg: 'hover'}"
                              data-kt-menu-attach="parent"
                              data-kt-menu-placement="bottom-end"
                            >
                              {filtersActive ? (
                                <span className="fw-bolder">Filtros activados</span>
                              ) : (
                                <span className="fw-bolder">Filtros</span>
                              )}
                              <Icon
                                icon="ki-filter"
                                size="fs-2"
                                className="hover-scale ms-2 fw-bolder"
                              />
                            </button>
                            <div
                              className="menu menu-sub menu-sub-dropdown menu-column fw-semibold py-3 w-auto min-w-200px max-w-full text-nowrap w-350px bg-dropFilter"
                              data-kt-menu="true"
                              style={{ minWidth: '20rem' }}
                            >
                              <div className="bg-dropFilter" onClick={(e) => e.stopPropagation()}>
                                <div className="card-header card-header-content-between pb-2 pt-5">
                                  <div className="fs-5 text-gray-900 fw-bolder mt-3">
                                    Selecciona los filtros <br />
                                    <span className="text-primary fs-7">
                                      Ambos campos son obligatorios.
                                    </span>
                                  </div>
                                </div>
                                <div className="card-body">
                                  <div className="mb-7">
                                    <label className="form-label">
                                      {t('blacklist-page.company-label')}
                                      <span className="fs-8 text-muted ms-1"></span>
                                    </label>
                                    <div className="row">
                                      <div className="col">
                                        <Controller
                                          control={control}
                                          name={'companies'}
                                          render={({ field: { onChange, value } }) => (
                                            <Select
                                              options={companies}
                                              isClearable
                                              noOptionsMessage={({ inputValue }) =>
                                                inputValue
                                                  ? t('general.no-options', { inputValue })
                                                  : t('general.no-options')
                                              }
                                              value={
                                                companies.filter((option: any) =>
                                                  value?.includes(option.value)
                                                ) || []
                                              }
                                              onChange={(selectedOption) => {
                                                const selectedValue = selectedOption?.value || '';
                                                setSelectedCompany(selectedOption?.value || '');
                                                onChange(selectedValue);
                                                setAccount([]);
                                              }}
                                              placeholder={t('blacklist-page.company-placeholder')}
                                              className="form-select-custom"
                                              classNamePrefix="form-select-custom"
                                            />
                                          )}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="mb-4">
                                    <label className="form-label fw-semibold">Cuentas</label>
                                    <div className="row">
                                      <div className="col">
                                        <Controller
                                          control={control}
                                          name={'account'}
                                          render={({ field: { onChange, value } }) => (
                                            <Select
                                              options={account}
                                              noOptionsMessage={({ inputValue }) =>
                                                inputValue
                                                  ? t('general.no-options', { inputValue })
                                                  : t('general.no-options')
                                              }
                                              isClearable
                                              onChange={(selectedOption) => {
                                                const selectedValue = selectedOption?.value || '';
                                                onChange(selectedValue);
                                                if (selectedValue === '') {
                                                  setFiltersActive(false);
                                                } else {
                                                  setDataPreview('');
                                                  setTypePreview('');
                                                }
                                              }}
                                              value={
                                                account.find(
                                                  (option: any) => option.value === value
                                                ) || ''
                                              }
                                              placeholder={t('blacklist-page.company-placeholder')}
                                              className="form-select-custom"
                                              classNamePrefix="form-select-custom"
                                            />
                                          )}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="card-body pt-1">
                        <Datatable columns={columns} data={rows} isLoading={isRequesting} />
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4">
                    <div className="ms-10 sticky-box">
                      <AndroidMockup type={typePreview} payload={dataPreview} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
          <SendMessageRCS
            show={showModalMessageRCS.show}
            payload={selectedTemplate}
            onRequestClose={() => setShowModalMessageRCS({ show: false, data: null })}
          />
          <TypeRCS
            show={showModalTypeRCS.show}
            payload={showModalTypeRCS.data}
            onRequestClose={() => setShowModalTypeRCS({ show: false, data: null })}
          />
        </div>
      </div>
    </>
  );
}

export default TemplatesRcsPage;
